type Props = {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  light?: boolean;
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  light = false,
}: Props) {
  return (
    <div className={align === "center" ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
      {eyebrow && (
        <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
          <i className="ri-map-pin-2-line"></i>
          {eyebrow}
        </span>
      )}
      <h2
        className={`mt-3 font-heading text-2xl font-bold md:text-3xl ${
          light ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p
          className={`mt-3 text-sm leading-relaxed md:text-base ${
            light ? "text-background-50/70" : "text-foreground-600"
          }`}
        >
          {desc}
        </p>
      )}
    </div>
  );
}